<div>
    <h1 categoryPageStyles class="text-l ttu m-0 seo-category">
        {{ seoCategoryName }}
    </h1>
</div>

<ul
    class="grid-product-list pb-64 grid-product-list-3"
    infiniteScroll
    [infiniteScrollDistance]="4"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScroll()"
>
    <li class="grid-product grid-product-view3 sk-load3" *ngFor="let productId of productIds; let indexOfElement = index">
        <product-view
            class="full-size p-view"
            [productId]="productId"
            [categoryConfig]="categoryConfiguration"
            [config]="templateConfiguration"
            [category]="category"
            [defaultSet0Activated]="false"
            [elementIndex]="indexOfElement"
            [defaultImageType]="defaultImageTypes?.[productId]"
        ></product-view>
    </li>
</ul>

@defer (on viewport) {
    @if (showLastSizesGrid) {
        <app-grid-last-sizes
            [category]="category"
            [isCategoryNew]="isCategoryNew"
            [defaultImageTypes]="defaultImageTypes"
            [gridType]="3"
            [showMediaCarousel]="showMediaCarousel"
            [templateConfiguration]="templateConfiguration"
        ></app-grid-last-sizes>
    }
} @placeholder {
    <div class="alterative-grids-container"></div>
}
